import { render, staticRenderFns } from "./BlockOption.vue?vue&type=template&id=7a3d5924&scoped=true&"
import script from "./BlockOption.vue?vue&type=script&lang=js&"
export * from "./BlockOption.vue?vue&type=script&lang=js&"
import style0 from "./BlockOption.vue?vue&type=style&index=0&id=7a3d5924&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a3d5924",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
